module.exports = __webpack_public_path__ + "static/policies-list-38cba353bff9dceb46d2ba1bff00b452.png";